var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.isPanelVisible && _vm.$store.getters["comparisonDataUpdated"]
    ? _c(
        "div",
        {
          staticStyle: {
            position: "absolute",
            "z-index": "100",
            bottom: "35px",
            right: "10px",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                background: "#ffffff",
                display: "flex",
                "flex-wrap": "wrap",
                width: "600px",
                "border-radius": "5px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1 0 200px",
                    display: "flex",
                    "justify-content": "space-between",
                    padding: "5px 5px 5px 10px",
                  },
                },
                [
                  _c("div", [
                    _c("div", { staticStyle: { "font-weight": "700" } }, [
                      this.displayedLayers[0]
                        ? _c("span", { staticStyle: { color: "#585858" } }, [
                            _vm._v(_vm._s(this.displayedLayers[0].title)),
                          ])
                        : _c("span", { staticStyle: { color: "#cbcbcb" } }, [
                            _vm._v(_vm._s(_vm.$t("noLayer"))),
                          ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { color: "#7a7a7a" } }, [
                      this.displayedLayers[0]
                        ? _c(
                            "span",
                            { staticStyle: { "white-space": "pre-line" } },
                            [_vm._v(_vm._s(this.displayedLayers[0].timeString))]
                          )
                        : _c("span", [_vm._v(" - ")]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        flex: "0 0",
                        display: "flex",
                        "flex-direction": "column",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("b-button", {
                        staticStyle: { color: "#585858" },
                        attrs: {
                          size: "is-small",
                          type: "is-ghost",
                          "icon-right": "swap-horizontal",
                          disabled:
                            this.$store.getters["isComparisonModeActive"],
                        },
                        on: {
                          click: function ($event) {
                            return _vm.swapLayers()
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("b-button", {
                        staticStyle: { color: "#585858" },
                        attrs: {
                          size: "is-small",
                          type: "is-ghost",
                          "icon-right": "delete",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.removeLayer(0)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticStyle: { flex: "0 0 1px", background: "#dbdbdb" },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1 0 200px",
                    display: "flex",
                    "justify-content": "space-between",
                    padding: "5px 5px 5px 10px",
                  },
                },
                [
                  _c("div", [
                    _c("div", { staticStyle: { "font-weight": "700" } }, [
                      this.displayedLayers[1]
                        ? _c("span", { staticStyle: { color: "#585858" } }, [
                            _vm._v(_vm._s(this.displayedLayers[1].title)),
                          ])
                        : _c("span", { staticStyle: { color: "#cbcbcb" } }, [
                            _vm._v(_vm._s(_vm.$t("noLayer"))),
                          ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { color: "#7a7a7a" } }, [
                      this.displayedLayers[1]
                        ? _c(
                            "span",
                            { staticStyle: { "white-space": "pre-line" } },
                            [_vm._v(_vm._s(this.displayedLayers[1].timeString))]
                          )
                        : _c("span", [_vm._v(" - ")]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        flex: "0 0",
                        display: "flex",
                        "flex-direction": "column",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("b-button", {
                        staticStyle: { color: "#585858" },
                        attrs: {
                          size: "is-small",
                          type: "is-ghost",
                          "icon-right": "swap-horizontal",
                          disabled:
                            this.$store.getters["isComparisonModeActive"],
                        },
                        on: {
                          click: function ($event) {
                            return _vm.swapLayers()
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("b-button", {
                        staticStyle: { color: "#585858" },
                        attrs: {
                          size: "is-small",
                          type: "is-ghost",
                          "icon-right": "delete",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.removeLayer(1)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "margin-top": "5px",
                },
              },
              [
                _c(
                  "b-button",
                  {
                    attrs: {
                      "icon-left": "select-compare",
                      disabled:
                        _vm.displayedLayers[0] === undefined ||
                        _vm.displayedLayers[1] === undefined,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.compareLayers()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("compareLayers")))]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: { "icon-left": "exit-to-app" },
                    on: {
                      click: function ($event) {
                        return _vm.exitComparison()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("exitComparison")))]
                ),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }